import React, { Component } from 'react';
import { Banner } from '../../Components'
import logo from '../Pricing/gpbook-logo.svg'
import { observer, inject } from 'mobx-react'
import WOW from 'wowjs' 
import moment from 'moment'

@inject("store")
@observer
class Complete extends Component {

	componentDidMount() {
		new WOW.WOW({
			mobile: false,
		}).init();
		window.scrollTo(0, 0)
	}

	render() {
		
		const { purchase, onlinePrice, bookPrice,
			// combinePrice,
			totalPrice, combineBookPrice, combineOnlinePrice,
			// totalSubPrice
		} = this.props.store

	return (
	<div className="purchase-complete">
			<Banner title="Update Complete" subtitle="Thank you for submitting your update" />

			<div className="page" >
				<div className="container">


					<h2>Thank you for your order</h2>	

					<p className="m-t-1">We have received your purchase. If you have any other questions, please call or email us directly.</p>

					<p className="text-secondary m-t-1">
						<b>If you have made an online subscription, you will be granted access once our team has verified the details you have provided. We do this so that the private contact details of doctors in our directory remain safe. This process may take 1-2 business days.</b>
					</p>
					
					<hr />
					
					<h3>Order Reference: <b>{purchase.customer_id || "CM01"}</b></h3>

					<div className="row">
						<div className="col-md-8">
						<div className="tax-invoice">
						

							<div className="details">

								<img src={logo} alt="feature" width="92"/>
									<h3>GPbook WA</h3>		

							<div className="detail abn">
								<b>ABN: 63 139 723 321</b>
							</div>		
							
							<div className="detail website">
								<i className="fa fa-fw fa-globe"></i>https://www.gpbook.com.au
							</div>
									
							<div className="detail address">
								<i className="fa fa-fw fa-home"></i>PO BOX 140 Morley 6943
							</div>
							<div className="detail phone">
								<i className="fa fa-fw fa-envelope"></i>info@gpbook.com.au
							</div>
									
							{/* <div className="detail phone">
								<i className="fa fa-fw fa-phone"></i>0437789864
							</div> */}
									
						</div>

						<h2>Order Summary</h2>

						<div className="tax-details">
							
							<div className="detail">
								<b>Date:</b> {moment().format('D/M/YYYY')}
							</div>	
							<div className="detail">
								<b>Reference:</b> {purchase.customer_id || "CM01"}
							</div>			
							
						</div>
						
						
								<div className="to-whom">
									<div className="business-name">{purchase.name || "Business"}</div>
									<div className="contact">
										{purchase.contactName && <div><b>Attention:</b> {purchase.contactName}</div>}
										{purchase.address && <div>{purchase.address}</div>}
										{purchase.email && <div>{purchase.email}</div>}
										{purchase.phone && <div>{purchase.phone}</div>}
									</div>
								</div>

						<table className="table pricing">
								<thead>
									<tr>
										<th>Product</th>
										<th width="100">Quantity</th>
										<th width="150">Price <small>(inc GST)</small></th>
										<th width="150">Recurring</th>
									</tr>

								</thead>
								<tbody>
									{((purchase.bookQuantity + purchase.onlineQuantity + purchase.combineQuantity + purchase.psychQuantity) === 0) ? <tr>
										<td>No Product Items added yet. Please select a quantity from the Products section.</td>
										<td></td>
											<td></td>
										<td></td>	
									</tr> : null}

									{purchase.bookQuantity ? <tr>
										<td>
											<b>Papper Edition</b><br />
											Medical & Surgical Specialist Referral Directory</td>
										<td>{purchase.bookQuantity}</td>
											<th>${bookPrice.toFixed(2)}</th>
										<td></td>	
										</tr> : null}

									{/* {purchase.psychQuantity >=1 ? <tr>
										<td>
											<b>Psychology Edition (free)</b><br />
											Mental Health and Psychology Referral Directory
										</td>
										<td>1</td>
											<th>Free</th>
										<td></td>	
										</tr> : null}
										
									{purchase.psychQuantity > 1 ? <tr>
										<td>
											<b>Psychology Edition</b><br />
											Mental Health and Psychology Referral Directory
										</td>
										<td>{purchase.psychQuantity - 1}</td>
											<th>${this.props.store.psychPrice.toFixed(2)}</th>
										<td></td>	
										</tr> : null} */}

									{purchase.psychQuantity ? <tr>
										<td>
											<b>Psychology Edition</b><br />
											Mental Health and Psychology Referral Directory
										</td>
										<td>{purchase.psychQuantity}</td>
											<th>${this.props.store.psychPrice.toFixed(2)}</th>
										<td></td>	
										</tr> : null}

									{purchase.onlineQuantity ? <tr>
										<td>
											<b>Online Directory</b><br />
											Online Subscription<br />
											First Month Free. Billing automatically recurs until cancelled.
										</td>
										<td>
											{purchase.onlineQuantity}
										</td>
											<th>
												$0 for first month
											</th>
											<th>
												${onlinePrice.toFixed(2)}/per year
											</th>
									</tr> : null}
									


									<tr>
										<td></td>
										<td><b>Tax (GST)</b></td>
											<td>${((totalPrice) - (totalPrice / 1.1)).toFixed(2)}</td>
										<td></td>	
									</tr>

									<tr>
											<td style={{textAlign: 'right', paddingRight: 15}}>Up Front</td>
										<td><b>Total</b></td>
											<th>${totalPrice.toFixed(2)}</th>
										<td></td>	
									</tr>

									{(purchase.combineQuantity || purchase.onlineQuantity) ? <tr>
										<td colSpan="4" style={{ textAlign: 'center', paddingRight: 15 }}>
											After 1 month free trial, recurring payments will begin.
										</td>
										
									</tr> : null}		

								</tbody>
							</table>

								{/* <p><b>CONFIDENTIALITY NOTICE AND DISCLAIMER.</b> This item (including any attachment to it) is confidential and may also be privileged and exempt from disclosure under applicable law. Accordingly, if you are not the intended recipient, please notify us immediately and delete this email (including any attachment to it) from your computer system.  We do not assure the security of information electronically transmitted and your communication with us through such means signifies your acceptance of any risk attaching thereto. </p> */}
								
							</div>

						</div>

						
					</div>

					<h3 className="m-t-1">Your Order is on its way</h3>
						<p className="m-t-1">Our team will now prepare to pack and send any paper copies of the directory you have ordered.</p>
						<p className="m-t-1">If you have ordered an online subscription, our team will verify your registration details and activate your account as soon as possible. This process may take 1-2 business days. We want to get you online as soon as we can but we need to complete this process to ensure that private details of the doctors who list on our system remain secure.</p>
						<p className="m-t-1">If you have any queries, please contact us at info@gpbook.com.au</p>
					
				</div>
			</div>
	  </div>
	)
  }
}

export default Complete


// WEBPACK FOOTER //
// ./src/Containers/Purchase/Complete.js